import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Grid, Paper, Typography, Box, Divider } from '@material-ui/core'
import { OverlayTrigger, Tooltip } from 'react-bootstrap'
import { withStyles } from '@material-ui/core/styles'
import { styles } from '../../classes/Styles'
import LinearProgress from '@material-ui/core/LinearProgress'

import { SUBSCRIBER_GENRE } from '../../constants/module_info'
import { CATALOG_NETWORK_DEFAULT1, CATALOG_NETWORK_DEFAULT2, CATALOG_NETWORK_PRIMARY } from '../../constants/colors'

const BorderLinearProgressPrimary = withStyles((theme) => ({
  root: {
    height: 16,
    borderRadius: 0
  },
  colorPrimary: {
    backgroundColor: theme.palette.grey[theme.palette.type === 'light' ? 200 : 700]
  },
  bar: {
    borderRadius: 0,
    backgroundColor: CATALOG_NETWORK_PRIMARY
  }
}))(LinearProgress)

const BorderLinearProgressDefault1 = withStyles((theme) => ({
  root: {
    height: 16,
    borderRadius: 0
  },
  colorPrimary: {
    backgroundColor: theme.palette.grey[theme.palette.type === 'light' ? 200 : 700]
  },
  bar: {
    borderRadius: 0,
    backgroundColor: CATALOG_NETWORK_DEFAULT1
  }
}))(LinearProgress)
const BorderLinearProgressDefault2 = withStyles((theme) => ({
  root: {
    height: 16,
    borderRadius: 0
  },
  colorPrimary: {
    backgroundColor: theme.palette.grey[theme.palette.type === 'light' ? 200 : 700]
  },
  bar: {
    borderRadius: 0,
    backgroundColor: CATALOG_NETWORK_DEFAULT2
  }
}))(LinearProgress)

export class SubscriberOwnershipComponent extends Component {
  static propTypes = {
    classes: PropTypes.object.isRequired,
    primaryNetwork: PropTypes.object,
    defaultNetwork1: PropTypes.object,
    defaultNetwork2: PropTypes.object,
    subscriber: PropTypes.object
  }

  constructor (props) {
    super(props)

    this.state = {
      primaryNetworkOwnership: null,
      defaultNetwork1Ownership: null,
      defaultNetwork2Ownership: null
    }
  }

  componentDidUpdate (prevProps) {
    if (this.props.subscriber.details &&
      (prevProps.primaryNetwork !== this.props.primaryNetwork && this.props.primaryNetwork) ||
      (prevProps.defaultNetwork1 !== this.props.defaultNetwork1 && this.props.defaultNetwork1) ||
      (prevProps.defaultNetwork2 !== this.props.defaultNetwork2 && this.props.defaultNetwork2)) {
      const newReleases = this.props.subscriber.details.top_title_ownership
      this.setState({
        primaryNetworkOwnership: newReleases.filter(n => n.data.data.network === this.props.primaryNetwork.network)[0],
        defaultNetwork1Ownership: newReleases.filter(n => n.data.data.network === this.props.defaultNetwork1.network)[0],
        defaultNetwork2Ownership: newReleases.filter(n => n.data.data.network === this.props.defaultNetwork2.network)[0]
      })
    }
  }

  getPercentage = (count, totalCount) => {
    return Math.round((count / totalCount) * 100)
  }

  render () {
      const { classes } = this. props
      const { primaryNetworkOwnership, defaultNetwork1Ownership, defaultNetwork2Ownership } = this.state
      return (
        <Paper className={`metricBox ${classes.paper}`}>
          <Grid container spacing={1} direction="column">
            <Grid item className='cardPadding p-b-0'>
              <span className={`metricTitle ${classes.cardTitle}`}>Ownership of Top 250 Titles</span>
              <OverlayTrigger overlay={<Tooltip id="tooltip">{SUBSCRIBER_GENRE}</Tooltip>} placement="right">
                <img className={classes.cardInfo} src="/static/images/info.png" alt="info"/>
              </OverlayTrigger>
            </Grid>
            <Grid item className={`metric-sub ${classes.cardSubTitle}`}>The top 250 engaged with pieces of content YTD</Grid>
          </Grid>
          { primaryNetworkOwnership &&
            <Box className="boxStart primary">
              <Box className="d-flex align-items-center">
                <Box className="w-25">
                  <Typography className="metricProLabel">{primaryNetworkOwnership.data.data.network}</Typography>
                </Box>
                <Box className="w-55 progressRotate">
                  <BorderLinearProgressPrimary variant="determinate" value={this.getPercentage(primaryNetworkOwnership.data.data.count, primaryNetworkOwnership.data.data.totalCount)} />
                </Box>
                <Box className="w-25 text-right">
                  <Typography className="metricProLabel">{primaryNetworkOwnership.data.data.count} ({this.getPercentage(primaryNetworkOwnership.data.data.count, primaryNetworkOwnership.data.data.totalCount)}%)</Typography>
                </Box>
              </Box>
              <Divider className="progressDivide"/>
            </Box>
          }
          { defaultNetwork1Ownership &&
            <Box className="defaultOne">
              <Box className="d-flex align-items-center">
                <Box className="w-25">
                  <Typography className="metricProLabel">{defaultNetwork1Ownership.data.data.network}</Typography>
                </Box>
                <Box className="w-55 progressRotate">
                  <BorderLinearProgressDefault1 variant="determinate" value={this.getPercentage(defaultNetwork1Ownership.data.data.count, defaultNetwork1Ownership.data.data.totalCount)} />
                </Box>
                <Box className="w-25 text-right">
                  <Typography className="metricProLabel">{defaultNetwork1Ownership.data.data.count} ({this.getPercentage(defaultNetwork1Ownership.data.data.count, defaultNetwork1Ownership.data.data.totalCount)}%)</Typography>
                </Box>
              </Box>
              <Divider className="progressDivide"/>
            </Box>
          }
          { defaultNetwork2Ownership &&
            <Box className="defaultTwo mb-3">
              <Box className="d-flex align-items-center">
                <Box className="w-25">
                  <Typography className="metricProLabel">{defaultNetwork2Ownership.data.data.network}</Typography>
                </Box>
                <Box className="w-55 progressRotate">
                  <BorderLinearProgressDefault2 variant="determinate" value={this.getPercentage(defaultNetwork2Ownership.data.data.count, defaultNetwork2Ownership.data.data.totalCount)} />
                </Box>
                <Box className="w-25 text-right">
                  <Typography className="metricProLabel">{defaultNetwork2Ownership.data.data.count} ({this.getPercentage(defaultNetwork2Ownership.data.data.count, defaultNetwork2Ownership.data.data.totalCount)}%)</Typography>
                </Box>
              </Box>
            </Box>
          }
        </Paper>
      )
  }
}

export default withStyles(styles)(SubscriberOwnershipComponent)
